import orderBy from 'lodash/orderBy';
import type { MaybeRef } from 'vue';
import { computed, ref } from 'vue';
import { useMarkets } from '@/core/oddsApi/composable/useMarkets';
import type { LeagueSize, SportType } from '@/interface/enum';

export function useMatchMarkets(
    matchId: MaybeRef<number>,
    isLive: MaybeRef<boolean>,
    sportType: SportType,
    leagueSize: LeagueSize,
    leagueId: number,
    isEnabled: MaybeRef<boolean> = ref(true),
) {
    const { markets, loaded, loading, refetch } = useMarkets(matchId, isLive, sportType, leagueSize, leagueId, isEnabled);

    const sortedMarkets = computed(() => {
        const sortedMarketsSelections = markets.value.map(market => ({
            ...market,
            selections: orderBy(market.selections, [selection => selection.selectionOrder, selection => selection.id]),
        }));

        return orderBy(sortedMarketsSelections, [market => market.displayPriority, market => market.id]);
    });

    return {
        sortedMarkets,
        loaded,
        loading,
        refetch,
    };
}
